export interface IApplicationState {

    showSoundActiveScreen: boolean;
    startResize: boolean;
    soundActiveScreenVisible: boolean;
    // introPageSelected: number

}

const initialState: IApplicationState = {
    showSoundActiveScreen: false,
    startResize: false,
    soundActiveScreenVisible: true,
    //introPageSelected: 1,
};

export enum actionTypes {

    SHOW_SOUND_ACTIVE_SCREEN = '@@soundActiveScreen/SHOW_SOUND_ACTIVE_SCREEN',
    HIDE_SOUND_ACTIVE_SCREEN = '@@soundActiveScreen/HIDE_SOUND_ACTIVE_SCREEN',
    START_RESIZE_SOUND_ACTIVE_SCREEN = '@@soundActiveScreen/START_RESIZE_SOUND_ACTIVE_SCREEN',
    VISIBILITY_OF_SOUND_ACTIVE_SCREEN = '@@soundActiveScreen/VISIBILITY_OF_SOUND_ACTIVE_SCREEN',

}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { soundActiveScreenVisible } = action;
    switch (action.type) {
        case actionTypes.SHOW_SOUND_ACTIVE_SCREEN:
            return {
                ...state, showSoundActiveScreen: true,
            };
        case actionTypes.HIDE_SOUND_ACTIVE_SCREEN:

            return {
                ...state, showSoundActiveScreen: false,
            };
        case actionTypes.START_RESIZE_SOUND_ACTIVE_SCREEN:

            return {
                ...state, startResize: true,
            };
        case actionTypes.VISIBILITY_OF_SOUND_ACTIVE_SCREEN:

            return {
                ...state, soundActiveScreenVisible: soundActiveScreenVisible,
            };

        default:
            return state;
    }
}

export const actions = {
    soundActiveScreenShow: (): any => ({ type: actionTypes.SHOW_SOUND_ACTIVE_SCREEN }),
    hideSoundActiveScreen: (): any => ({ type: actionTypes.HIDE_SOUND_ACTIVE_SCREEN }),
    resizeStart: (): any => ({ type: actionTypes.START_RESIZE_SOUND_ACTIVE_SCREEN }),
    visibleSoundActiveScreen: (soundActiveScreenVisible: boolean): any => ({ type: actionTypes.VISIBILITY_OF_SOUND_ACTIVE_SCREEN, soundActiveScreenVisible }),


};
